export enum CanvasShapeType {
  Square = 'square',
  SquareRounded = 'squareRounded',
  Circle = 'circle',
  Rectangle = 'rectangle',
  RectangleRounded = 'rectangleRounded',
  Triangle = 'triangle',
}

export enum DesignerMode {
  CustomImage = 'CustomImage',
  PredefinedLabel = 'PredefinedLabel',
  CartItemDetail = 'CartItemDetail',
}
